// extracted by mini-css-extract-plugin
export default {"text":"HomeBottomNavigationText_text__DgKvt"};